import { render, staticRenderFns } from "./app-info-thumbnail.vue?vue&type=template&id=4ebc1fb8&scoped=true&"
import script from "./app-info-thumbnail.vue?vue&type=script&lang=js&"
export * from "./app-info-thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./app-info-thumbnail.vue?vue&type=style&index=0&id=4ebc1fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc1fb8",
  null
  
)

export default component.exports